import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireAdminMiddleware from 'middlewares/RequireAdminMiddleware'
import RoutesEnum from 'enums/routes.enum'

export default [
    {
        path: '/admin/reservations/:type',
        name: RoutesEnum.ADMIN.RESERVATIONS,
        view: 'admin/Reservations',
        middlewares: [RequireUserMiddleware, RequireAdminMiddleware],
        meta: {
            layout: 'main',
            title: '',
            description: '',
        },
    },
    {
        path: '/admin/activate-member',
        name: RoutesEnum.ADMIN.ACTIVATE_MEMBER,
        view: 'admin/ActivateMember',
        middlewares: [RequireUserMiddleware, RequireAdminMiddleware],
        meta: {
            layout: 'main',
            title: '',
            description: '',
        },
    },
]
